import Modal from '@resources/js/ui/Modal';
const CURRENCY_PARAM = 'cur_id';
const currencyModalElement = document.querySelector('.js-currency-modal');
if (currencyModalElement) {
    new Modal(currencyModalElement, {
        trigger: '.js-currency-modal-open',
        selectors: {
            close: '.js-currency-modal-close',
            content: '.js-currency-modal-content',
        },
    });
    const currencyItemElements = currencyModalElement.querySelectorAll('.js-currency-item');
    // URL збираємо в момент кліку — location вже містить фільтри, змінені через pushState
    currencyItemElements.forEach(itemElement => {
        itemElement.addEventListener('click', () => {
            const { currencyId } = itemElement.dataset;
            if (!currencyId)
                return;
            const url = new URL(window.location.href);
            url.searchParams.set(CURRENCY_PARAM, currencyId);
            location.href = url.toString();
        });
    });
}
